module.exports = __webpack_public_path__ + "static/media/14-4.d6dc54b4.mp3";